import { render, staticRenderFns } from "./ReceipesTest.vue?vue&type=template&id=4af0a57b&scoped=true&"
import script from "./ReceipesTest.vue?vue&type=script&lang=js&"
export * from "./ReceipesTest.vue?vue&type=script&lang=js&"
import style0 from "./ReceipesTest.vue?vue&type=style&index=0&id=4af0a57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0a57b",
  null
  
)

export default component.exports